import {useReducer} from "react";
import {
  variantListAccordionReducer,
  initialVariantListAccordionState,
} from "../reducers/accordion";

export function useVariantListAccordion({
  reducer = variantListAccordionReducer,
}: {
  reducer: typeof variantListAccordionReducer;
}) {
  const [state, dispatch] = useReducer(reducer, initialVariantListAccordionState);
  const toggleIndex = (index: number) => dispatch({type: "toggle_index", payload: index});
  const resetState = () => dispatch({type: "reset-state"});
  return {openIndexes: state.openIndexes, toggleIndex, resetState};
}
